module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author-item"
  }, [_c('div', {
    staticClass: "row m-0 align-items-end justify-content-between"
  }, [_c('h5', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.author.firstName) + " " + _vm._s(_vm.author.lastName) + "\n      "), _c('a', {
    staticClass: "envelope",
    attrs: {
      "href": ("mailto:" + (_vm.author.email))
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope-o"
    }
  })], 1)]), _vm._v(" "), (!_vm.$store.state.isEnhanced) ? _c('social-media-buttons', {
    staticClass: "m-0 hidden-md-down",
    attrs: {
      "media-links": _vm.author.mediaLinks
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-4 p-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/' + _vm.author.photoUrl)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col description"
  }, [_c('div', [_vm._v(_vm._s(_vm.author.institution) + ",")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.author.location))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.author.description))]), _vm._v(" "), _c('p', [_vm._t("details-link")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f3492fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AuthorComponent.vue
// module id = 1465
// module chunks = 1